import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { LanguageService } from 'imakeapp-shared';
import { AppService } from 'src/app/Services/AppService/app.service';
import { update_app_loader_action } from 'src/app/store/app.action';







@Component({
  selector: 'app-top-level',
  templateUrl: './top-level.component.html',
  styleUrls: ['./top-level.component.scss']
})
export class TopLevelComponent implements OnInit
{


  lang =  'en';
  site_attributes: any;




  theme_data = {
    navigation_theme: '',
    footer_theme: ''
  };





  constructor(
    private lang_s: LanguageService,
    private store: Store,
    private router: Router
  ) { }

  ngOnInit(): void
  {


    this.request_site_language();

    this.stop_loader();


  }




  request_site_language()
  {

    // get active site language
    this.lang = this.lang_s.get_site_active_lang_code();

console.log(this.lang)
    // set site direction (based on language)
    document.getElementsByTagName('html')[0].setAttribute('dir', this.lang == 'ar' ? 'rtl' : 'ltr');
    document.getElementsByTagName('html')[0].setAttribute('lang', this.lang || 'en');

  }





  get_theme_data()
  {

    // this.app_service.get_site_theme().subscribe(
    //   (response : any)=>{

    //     if ( !Object.keys(response).length  ) return;


    //     // set theme data
    //     this.set_theme_data(response);

    //   },
    //   (err: any)=>{
    //     console.error(err);
    //   }
    // );

  }



  set_theme_data(website_attributes: any)
  {

    this.theme_data.navigation_theme = website_attributes['navigation_theme'];
    this.theme_data.footer_theme = website_attributes['footer_theme'];

  }



  stop_loader()
  {

    setTimeout( ()=>{
      this.store.dispatch( new update_app_loader_action(false) );
    } , 3000 );


  }




}
